import {
  SYSTEM_THEME_KEY,
  SYSTEM_THEME_LIGHT,
} from '@/pages/home/_config/config';
import type { IEmbedPreference } from './types';

export const PREFERENCE_UPDATE_TYPE = 'databrain:preference:update';

/** 与主站 ThemeContext 一致；无 Context 时读 localStorage */
export const readThemeFromStorage = (): string =>
  localStorage.getItem(SYSTEM_THEME_KEY) || SYSTEM_THEME_LIGHT;

/**
 * 解析 iframe postMessage 的 targetOrigin。
 * auth_path 常为相对路径（如 /as/report/xxx/index.html），须用当前页 origin 作为 base。
 */
export const resolveEmbedTargetOrigin = (rawUrl: string): string => {
  const base = rawUrl.trim();
  if (!base) return '';
  try {
    if (typeof window === 'undefined') return '';
    return new URL(base, window.location.origin).origin;
  } catch {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
};

/** 在 URL hash 中携带 language/theme（不进 Referer / server log） */
export const buildEmbedPreferenceUrl = (
  rawUrl: string,
  preference: IEmbedPreference,
): string => {
  const base = rawUrl.trim();
  if (!base) return '';
  const sep = base.includes('#') ? '&' : '#';
  const parts = [
    `language=${encodeURIComponent(preference.language)}`,
    `theme=${encodeURIComponent(preference.theme)}`,
  ];
  return `${base}${sep}${parts.join('&')}`;
};
